"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
import SelectionList from "../../util/selection_list";
import ReactUtils from "../../react_utils";
import Api from "../../api/api";
import _ from "underscore";
var selectionList = SelectionList(_.identity);
var bem = ReactUtils.makeBem("carrier-labels-editor");
function chunk(array, chunkSize) {
  return _.reduce(
    array,
    (reducer, item, index) => {
      reducer.current.push(item);
      if (reducer.current.length === chunkSize || index + 1 === array.length) {
        reducer.chunks.push(reducer.current);
        reducer.current = [];
      }
      return reducer;
    },
    { current: [], chunks: [] }
  ).chunks;
}
export default React.createClass({
  render: function() {
    this.eventHandlers = selectionList.react.eventHandlers(
      this.props.selectedLabels,
      this.props.labels
    );
    return /* @__PURE__ */ React.createElement("div", { className: bem() }, /* @__PURE__ */ React.createElement("div", { className: "row" }, _.map(this.inColumns(), this.renderColumn)), /* @__PURE__ */ React.createElement("div", { className: bem("__buttons") }, /* @__PURE__ */ React.createElement("a", { className: bem("__save"), onClick: this.props.onSave }, "Save Changes to Labels"), /* @__PURE__ */ React.createElement("a", { onClick: this.props.onCancel }, "Cancel")));
  },
  renderColumn(column, i) {
    let classes = "small-2 columns";
    if (i + 1 === this.inColumns().length) {
      classes += " end";
    }
    return /* @__PURE__ */ React.createElement("div", { className: classes }, _.map(column, this.label));
  },
  label: function(label) {
    return /* @__PURE__ */ React.createElement("label", { key: label }, /* @__PURE__ */ React.createElement(
      "input",
      __spreadValues({
        className: bem("__checkbox"),
        type: "checkbox"
      }, this.attributesForLabel(label))
    ), this.labelText(label));
  },
  labelText: function(label) {
    return this.isCarrierLabel(label) ? label + " (Assigned by Carrier)" : label;
  },
  attributesForLabel: function(label) {
    if (this.isCarrierLabel(label)) {
      return {
        disabled: true,
        checked: true
      };
    } else {
      return this.eventHandlers.checkboxBindings(label);
    }
  },
  isCarrierLabel: function(label) {
    return _.contains(this.props.carrierLabels, label);
  },
  inColumns() {
    const labels = this.visibleLabels();
    const length = labels.length;
    const partitions = this.columnCount();
    const chunkSize = Math.ceil(length / partitions);
    return chunk(labels, chunkSize);
  },
  visibleLabels() {
    return this.allLabels().filter((e) => e !== "QuickPay");
  },
  allLabels() {
    const accountLabelNames = this.accountLabels().map((label) => label.name);
    return _.uniq(this.props.labels.concat(accountLabelNames)).sort();
  },
  accountLabels() {
    return Api.Account.current().labels;
  },
  columnCount() {
    const minColumnHeight = 3;
    const maxColumnCount = 4;
    const tempColumnCount = Math.ceil(
      this.visibleLabels().length / minColumnHeight
    );
    return tempColumnCount > maxColumnCount ? maxColumnCount : tempColumnCount;
  }
});
